import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { getPlanTier, type PlanTier } from "src/utils/plan-tier";
import { cn } from "src/utils/cn";

interface PlanBadgeProps {
  planName: string | undefined;
  size?: "sm" | "md";
  labelMode?: "tier" | "original";
}

const tierStyles: Record<PlanTier, string> = {
  free: "bg-gray-100 text-gray-700",
  pro: "bg-primary-100 text-primary-700",
  enterprise: "bg-amber-100 text-amber-700",
};

const PlanBadge: FC<PlanBadgeProps> = ({
  planName,
  size = "md",
  labelMode = "tier",
}) => {
  const { t } = useTranslation("common");
  const tier = getPlanTier(planName);
  const label =
    labelMode === "original" && planName?.trim() ? planName : t(`plan.${tier}`);

  return (
    <span
      className={cn(
        "inline-flex items-center font-medium rounded-full whitespace-nowrap",
        tierStyles[tier],
        size === "sm"
          ? "px-1.5 py-0.5 text-[10px] leading-tight"
          : "px-2 py-0.5 text-xs",
      )}
    >
      {label}
    </span>
  );
};

export default PlanBadge;
